export default [
  {
    title: 'Save the Children',
    url: 'https://www.savethechildren.net/what-we-do/emergencies/ukraine-crisis',
       img: new URL('../images/support/save-the-children.png', import.meta.url).href

    },
  
  {
    title: 'Project HOPE',
    url: 'https://www.projecthope.org/country/ukraine/',
    img: new URL('../images/support/project-hope.png', import.meta.url).href,
    width: 62,
    height: 32,
    },
  {
    title: 'International Medical Corps',
    url: 'https://internationalmedicalcorps.org/country/ukraine/',
     img: new URL('../images/support/international-medical-corps.png', import.meta.url).href
    },
      {
    title: 'RAZOM',
        url: 'https://www.razomforukraine.org/',
     img: new URL('../images/support/razom.png', import.meta.url).href
  },
    {
    title: 'ACTION AGAINST HUNGER',
      url: 'https://www.actionagainsthunger.org/location/europe/ukraine/',
     img: new URL('../images/support/action-against-hunger.png', import.meta.url).href
  
    },
    {
    title: 'Charity Foundation SERGIY PRYTULA',
      url: 'https://prytulafoundation.org/en',
     img: new URL('../images/support/sergiy-prytula.png', import.meta.url).href
    },

  {
    title: 'MEDECINS SANS FRONTIERES',
    url: 'https://www.msf.org/ukraine',
     img: new URL('../images/support/medecins-sans-frontieres.png', import.meta.url).href
  },
  {
    title: 'World Vision',
    url: 'https://www.wvi.org/emergencies/ukraine',
     img: new URL('../images/support/world-vision.png', import.meta.url).href
  },
   {
    title: 'UNITED24',
     url: 'https://u24.gov.ua/uk',
     img: new URL('../images/support/united24.png', import.meta.url).href
    },
];
